/**
 * Employee labels that tell two people with the same name apart (persona
 * round 2026-10: two "Meera Joshi"s were indistinguishable in payroll
 * warnings, the lock dialog, the directory and pickers).
 *
 * personDetail → "EMP-012 · Engineering" (only the parts that exist)
 * personLabel  → "Meera Joshi (EMP-012 · Engineering)"
 */

export interface PersonBits {
  name: string;
  employeeCode?: string | null;
  department?: string | null;
}

export function personDetail(p: Omit<PersonBits, "name">): string {
  return [p.employeeCode, p.department]
    .map((s) => (s ?? "").trim())
    .filter(Boolean)
    .join(" · ");
}

export function personLabel(p: PersonBits): string {
  const name = p.name.trim();
  const detail = personDetail(p);
  if (!detail) return name;
  return name ? `${name} (${detail})` : detail;
}

/**
 * Names that occur more than once in a roster (case-insensitive, trimmed) —
 * for screens that only add the detail when it is needed.
 */
export function duplicateNames(names: readonly string[]): Set<string> {
  const seen = new Map<string, number>();
  for (const n of names) {
    const k = n.trim().toLowerCase();
    if (!k) continue;
    seen.set(k, (seen.get(k) ?? 0) + 1);
  }
  const out = new Set<string>();
  for (const [k, c] of seen) if (c > 1) out.add(k);
  return out;
}
